<template>
  <el-container>
    <el-header>
      新增快递信息
      <el-divider></el-divider>
    </el-header>

    <el-main>
      <div class="main">
        <div class="form">
          <el-form ref="expressForm" :model="expressForm" :rules="rules" label-width="120px" :label-position="labelPosition">
            <el-form-item label="快递单号" prop="expressNumber">
              <el-input v-model="expressForm.expressNumber"></el-input>
            </el-form-item>

            <el-form-item label="收货人" prop="serviceName">
              <el-input v-model="expressForm.serviceName"></el-input>
            </el-form-item>
            <el-form-item label="收货人手机号" prop="servicePhone">
              <el-input v-model="expressForm.servicePhone"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button size="medium" type="primary" @click="submitForm('expressForm')">提交</el-button>
              <el-button size="medium" @click="resetForm('expressForm')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>

      </div>

    </el-main>
  </el-container>

</template>
<script>

  export default {
    name: "AddExpress",
    data() {
      return {
        labelPosition: 'right',
        expressForm: {
          expressNumber: '',
          serviceName: '',
          servicePhone: '',
        },
        rules: {
          expressNumber: [
            {required: true, message: '请输入快递单号', trigger: 'blur'},
          ],
          serviceName: [
            {required: true, message: '请输入收货人姓名', trigger: 'blur'}
          ],
          servicePhone: [
            {required: true, message: '请输入收货人手机号', trigger: 'blur'},
          ]
        },
      }

    },
    methods: {
      /**
       * 提交快递单号，收货人，收货人手机号 信息
       * @param formName  表单信息
       */
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$axios.post("https://yuanteng.tech:8081/express/add_express", this.expressForm).then(res => {
              if (res.data.status) {
                this.$message.success(res.data.msg);
                this.resetForm(formName);
              } else {
                this.$message.error(res.data.msg);
              }
            })
          } else {
            // console.log('error submit!!');
            return false;
          }
        });
      },
      //重置
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },

      //处理表单标签的位置
      handleResize() {
        if (window.innerWidth < 768) {
          this.labelPosition = "top";
        } else {
          this.labelPosition = "right";
        }
      },
    },
    created() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    }
  }
</script>

<style scoped>
  .el-form {
    width: 100%;
  }

  .main {
    display: flex;
    flex-wrap: wrap;
  }

  .el-divider--horizontal {
    width: 100px;
    margin: 10px 0;
  }

  .el-divider {
    background-color: #257ac7;
  }


  @media screen {
    /deep/ .el-form--label-top .el-form-item__label {
      padding: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/express/AddExpress.vue